import { Image, Text, VStack } from "@chakra-ui/react";
import { FC } from "react";
import { NavLink } from "react-router-dom";

import { TableDataStickyColumn } from "~/src/components/common/tables/Table";
import { URLItem } from "~/src/components/common/URLItem";

import { ColumnData } from "./ReportTableDataColumn";

export type Prop = {
  data: ColumnData;
  key: number;
};

export const ReportTableDataStickyColumn: FC<
  React.PropsWithChildren<React.PropsWithChildren<Prop>>
> = ({ data, key }) => {
  if (data.type === "GROUP" && data.columns && data.columns.length > 0)
    return (
      <TableDataStickyColumn
        type="text"
        data={
          <VStack>
            {data.columns.map((c, index) => {
              if (c.type === "IMAGE")
                return (
                  <Image
                    src={c.value}
                    boxSize={"50px"}
                    fit={"contain"}
                    key={index}
                  />
                );
              if (c.type === "URL_LINK")
                return <URLItem url={c.url || ""} name={c.value} key={index} />;
              if (c.type === "NAV_LINK" && c.url !== undefined)
                return (
                  <NavLink to={c.url} key={index}>
                    <Text as="u">{c.value}</Text>
                  </NavLink>
                );
              return <Text key={index}>{c.value}</Text>;
            })}
          </VStack>
        }
        key={key}
      />
    );
  if (data.type === "IMAGE")
    return (
      <TableDataStickyColumn
        type="text"
        data={<Image src={data.value} boxSize={"50px"} fit={"contain"} />}
        key={key}
      />
    );

  if (data.type === "URL_LINK")
    return (
      <TableDataStickyColumn
        type="text"
        data={<URLItem url={data.url || ""} name={data.value} />}
        key={key}
      />
    );
  if (data.type === "NAV_LINK" && data.url !== undefined)
    return (
      <TableDataStickyColumn
        type="text"
        data={
          <NavLink to={data.url}>
            <Text as="u">{data.value}</Text>
          </NavLink>
        }
        key={key}
      />
    );
  return <TableDataStickyColumn type="text" data={data.value} key={key} />;
};
